import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HeaderComponent } from '../header/header.component';

@Component({
	selector: 'kwo-layout',
	templateUrl: './layout.component.html',
	styleUrl: './layout.component.scss',
	standalone: true,
	imports: [HeaderComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutComponent {

}
